export const SECTION_BULLET_LIST_QUERY = `SectionBulletList {
    forProject
    title {
      html
    }
    items {
      html
    }
    textColor {
      hex
    }
    backgroundColor {
      hex
    }
    borderColor {
      hex
    }
    borderWidth
    titleFontSize
  }`;
